/* eslint-disable */
import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { CSVLink } from "react-csv";

class CsvExportDetails extends Component {
  constructor(props){
    super(props);
    this.setPdfName = this.setPdfName.bind(this);
  }
  componentDidMount(){
    this.props.actions.getReportsData();
  }

  setPdfName(imageKey) {
    let fileName = imageKey.replace(/^.*[\\\/]/, '').replace('jpg','pdf');;
    return fileName;
  }

  render() {
    let rptData = null;
    console.log(this.props.reportsData);
    if (this.props.reportsData) {
        rptData = this.props.reportsData.map(rpt => {
          return {
            id: rpt.reportData.id,
            capIqr: rpt.reportData.capIqr, // 2 digits
            cap: rpt.reportData.cap, // 3 digits
            ism: rpt.reportData.ism, //  1.2
            ismIqr: rpt.reportData.ismIqr, // 1.4
            ismIqrPercentage: rpt.reportData.ismIqrPercentage, // prcentage
            file: this.setPdfName(rpt.imageLink.Key),
          }
      })
    }

    let headers = [
      { label: "Report ID", key: "id" },
      { label: "CAP IQR", key: "capIqr" },
      { label: "CAP (dB/m)", key: "cap" },
      { label: "ISM (KPa)", key: "ism" },
      { label: "ISM IQR", key: "ismIqr" },
      { label: "ISM IQR/med. (%)", key: "ismIqrPercentage" },
      { label: "File", key: "file" }
    ];
    console.log('rptData',rptData);
    return (
      <div className="mt-4 ml-4">
        {
          rptData ? 
          (
            <CSVLink
              data={rptData}
              headers={headers}
              filename={"reports-summary.csv"}
              className="btn btn-primary"
              target="_blank"
            >
              Download CSV
            </CSVLink>
          ) : (
            <Alert color="warning" className="mt-3" > No Data to export </Alert>
          )
        }
      </div>
    );
  }
}
CsvExportDetails.defaultProps = {
  reportsData: null,
};
CsvExportDetails.propTypes = {
  reportsData: PropTypes.array,
  actions: PropTypes.shape({
    getReportsData: PropTypes.func.isRequired,
  }).isRequired,
};

export default CsvExportDetails;



// WEBPACK FOOTER //
// ./src/components/Reports/CsvExport.js